<template>
  <section class="about-section">
    <div class="container">
      
      <!-- Left Content: Card -->
      <div class="about-card">
        <div class="card-inner">
          <h2 class="section-title">
            关于<span class="highlight">北京至讯</span>
            <div class="title-underline"></div>
          </h2>
          
          <!-- Stats -->
          <div class="stats-container">
            <!-- Stat Item 1 -->
            <div class="stat-item">
              <div class="stat-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div class="stat-info">
                <div class="stat-number" data-target="100">0+</div>
                <div class="stat-label">专业技术团队</div>
              </div>
            </div>
            
            <div class="stat-divider"></div>

            <!-- Stat Item 2 -->
            <div class="stat-item">
              <div class="stat-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="8.5" cy="7" r="4"></circle>
                  <polyline points="17 11 19 13 23 9"></polyline>
                </svg>
              </div>
              <div class="stat-info">
                <div class="stat-number" data-target="300">0+</div>
                <div class="stat-label">服务企业客户</div>
              </div>
            </div>
          </div>

          <div class="section-desc">
            <p>
              北京至讯信息技术有限公司是腾讯在企业信息网络安全与AI应用领域的核心合作伙伴，专注于为企业提供融合“安全防御”与“智能进化”的数字化服务。我们致力于运用先进技术，帮助客户构建安全可信、智能驱动的新型智慧企业。
            </p>
            <p>
              通过基于腾讯安全产品的全栈防护能力与腾讯AI智能体平台的定制开发能力，我们为企业客户提供从安全咨询规划、智能威胁治理，到AI场景落地、业务自动化升级的一体化解决方案与服务，助力客户在保障数字资产安全的同时，实现业务的智能创新与降本增效。
            </p>
          </div>
          
          <button class="btn-more" @click="$emit('open-modal')">了解更多 <span class="arrow">&gt;</span></button>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  mounted() {
    this.initCountUp()
  },
  methods: {
    handleImageError(e) {
      e.target.style.display = 'none'
      e.target.parentElement.classList.add('fallback-map')
    },
    initCountUp() {
      const statNumbers = this.$el.querySelectorAll('.stat-number[data-target]')
      if (!statNumbers.length) return

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateCount(entry.target)
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.5 })

      statNumbers.forEach((el) => observer.observe(el))
    },
    animateCount(el) {
      const target = parseInt(el.getAttribute('data-target'), 10)
      const duration = 1500
      const startTime = performance.now()

      const step = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        const current = Math.floor(eased * target)
        el.textContent = current + '+'
        if (progress < 1) {
          requestAnimationFrame(step)
        } else {
          el.textContent = target + '+'
        }
      }

      requestAnimationFrame(step)
    }
  }
}
</script>

<style scoped>
.about-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #f4f8ff 0%, #e6f0ff 100%);
  position: relative;
  overflow: hidden;
}

.about-section::before {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 60%;
  height: 100%;
  background-image: url('../assets/AboutSection/map.png');
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;
  z-index: 1;
  pointer-events: none;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 60px);
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
}

/* Card */
.about-card {
  width: 100%;
  max-width: 860px; /* 从 760px 增加到 860px，让卡片更宽 */
  filter: drop-shadow(0 15px 40px rgba(0, 82, 217, 0.08));
  transform: translateX(-120px); /* 进一步向左移动，从 -80px 改为 -120px */
}

.card-inner {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 24px;
  padding: 50px 60px 50px 50px;
  clip-path: polygon(0 0, 100% 0, 92% 100%, 0 100%);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.8);
}

/* Blue Accent Line */
.card-inner::before {
  content: '';
  position: absolute;
  top: 60px;
  left: 0;
  width: 6px;
  height: 40px;
  background-color: #0052d9;
  border-radius: 0 4px 4px 0;
}

.section-title {
  font-size: clamp(28px, 3vw, 40px);
  color: #111;
  font-weight: 800;
  margin-bottom: 40px;
  position: relative;
  display: inline-block;
  letter-spacing: 1px;
}

.section-title .highlight {
  color: #0052d9;
}

.title-underline {
  position: absolute;
  bottom: -12px;
  left: 0;
  width: 60px;
  height: 5px;
  background-color: #0052d9;
  border-radius: 3px;
}

/* Stats Container */
.stats-container {
  display: flex;
  align-items: center;
  background-color: #f7f9fc;
  border-radius: 12px;
  padding: 24px 32px;
  margin-bottom: 36px;
  border: 1px solid #eef2f9;
  max-width: 660px; /* 同步调宽数据区域 */
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.stat-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #0052d9, #165dff);
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 82, 217, 0.2);
}

.stat-icon svg {
  width: 24px;
  height: 24px;
}

.stat-info {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 28px;
  font-weight: 800;
  color: #0052d9;
  line-height: 1;
  margin-bottom: 6px;
}

.stat-label {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background-color: #dcdfe6;
  margin: 0 32px;
}

/* Text Description */
.section-desc {
  color: #444;
  font-size: clamp(15px, 1.6vw, 18px);
  font-weight: 500;
  line-height: 2;
  margin-bottom: 40px;
  padding-right: 40px;
}

.section-desc p {
  margin-bottom: 16px;
  text-align: justify;
}

.section-desc p:last-child {
  margin-bottom: 0;
}

/* Button */
.btn-more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 36px;
  background: linear-gradient(90deg, #0052d9, #165dff);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 16px rgba(0, 82, 217, 0.2);
}

.btn-more:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 82, 217, 0.3);
}

.btn-more .arrow {
  font-family: monospace;
  font-size: 14px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .about-section::before {
    opacity: 0.3;
    width: 100%;
  }
  .about-card {
    max-width: 100%;
    transform: translateX(0);
  }
  .card-inner {
    clip-path: none;
    padding: 40px;
  }
  .section-desc {
    padding-right: 0;
  }
}

@media (max-width: 600px) {
  .about-section {
    padding: 60px 0;
  }
  .card-inner {
    padding: 30px 20px;
  }
  .card-inner::before {
    top: 40px;
    height: 30px;
  }
  .stats-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 20px;
  }
  .stat-divider {
    width: 100%;
    height: 1px;
    margin: 0;
  }
}
</style>